import { RENDER_SERVICE_PAGE } from 'Constants'

export const setServicePage = payload => dispatch =>
  dispatch({ type: RENDER_SERVICE_PAGE, payload })
